// extracted by mini-css-extract-plugin
export var chip = "_n7-2";
export var chipBody = "_n7-8";
export var chipHeader = "_n7-9";
export var chipWithKind = "_n7-7";
export var icon = "_n7-3";
export var kind = "_n7-a";
export var remove = "_n7-5";
export var removeIcon = "_n7-6";
export var row = "_n7-0";
export var rowHistorical = "_n7-1";
export var text = "_n7-4";